import { useContext } from "react";
import { AlertContext, ShowAlert } from "./AlertContext";

/**
 * Provides access to alerts.
 * @returns A function which, when called, shows alerts.
 */
export function useAlert(): ShowAlert {
  const { showAlert } = useContext(AlertContext);

  return showAlert;
}
